module.exports = __webpack_public_path__ + "static/img/btn1.6cdc5f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/btn1.png
// module id = hZmQ
// module chunks = 1